<template>
  <div class="aba-geral-wrapper">
    <section class="sidebar-notes">
      <h5 class="mb-1">
        <font-awesome-icon
          :icon="faBook"
          class="mr-2"
        />
        Anotações e histórico
      </h5>

      <b-form-textarea
        v-model="novaAnotacao"
        rows="3"
        placeholder="Digite uma anotação..."
      />

      <b-button
        variant="primary"
        class="mt-2"
        @click="adicionarAnotacao"
      >
        <font-awesome-icon
          :icon="faPlus"
          class="mr-1"
        />
        Adicionar Anotação
      </b-button>

      <hr class="my-2">

      <div
        v-if="historico.length === 0"
        class="text-muted mt-2"
      >
        Nenhuma anotação ainda.
      </div>

      <div
        v-for="(item, index) in historico"
        :key="index"
        class="timeline-item"
      >
        <div class="timeline-icon">
          <font-awesome-icon
            :icon="faCommentDots"
          />
        </div>

        <div class="timeline-content">
          <p class="mb-1">
            {{ item.texto }}
          </p>

          <small class="text-muted">
            <font-awesome-icon
              :icon="faClock"
              class="mr-1"
            />
            {{ item.data }}
            <span v-if="item.createdBy"> — {{ item.createdBy }}</span>
            <b-button
              v-if="!item.isSystem"
              size="sm"
              variant="link"
              class="p-0 ml-2"
              @click="deletarAnotacao(item.id)"
            >
              <font-awesome-icon
                :icon="faTrash"
                class="text-danger"
              />
            </b-button>
          </small>
        </div>
      </div>
    </section>
  </div>
</template>

<style>
  .status {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 2px 4px;
    border-radius: 6px;
    text-transform: uppercase;
    background-color: #fff3cd;
    color: #856404;
  }

  .aba-geral-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  /* coluna com historico (scroll apenas nela) */
  .sidebar-notes {
    max-height: 65vh;
    overflow-y: auto;
    padding-right: 6px;
  }

  .timeline-item {
    display: flex;
    gap: 10px;
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .timeline-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    font-size: 14px;
  }

  .timeline-content {
    flex: 1;
    min-width: 0;
  }

  .timeline-content p {
    font-size: 13px;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
</style>

<script>
import moment from 'moment'
import {
  faBook,
  faPlus,
  faCommentDots,
  faClock,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import api from '../../services/api'

export default {
  name: 'AbaGeralOportunidade',
  components: {
    FontAwesomeIcon,
  },
  props: {
    deal: {
      type: Object,
      required: true,
      default: () => ({
        Client: 0,
        Valor: 0,
        Status: '',
        ResponsavelNome: '',
        ResponsavelId: 0,
        Prazo: null,
        Cadastro: null,
        ResponsavelCadastro: null,
        id: 0,
      }),
    },
  },
  data() {
    return {
      oprotunidadeStatus: [],
      novaAnotacao: '',
      historico: [],
      faBook,
      faPlus,
      faCommentDots,
      faClock,
      faTrash,
    }
  },
  created() {
    this.oprotunidadeStatus = this.carregarOportunidadeStatus()
    this.loadNotes()
  },
  methods: {
    async loadNotes() {
      this.$isLoading = true
      try {
        const res = await api.getDealNotes(this.deal.id)
        const notes = res && res.data ? res.data : []
        this.historico = notes.map(n => ({
          id: n.id || n.Id || 0,
          texto: n.content || n.Content || '',
          data: n.createdAt || n.CreatedAt || '',
          isSystem: n.isSystem || n.IsSystem || false,
          createdBy: n.createdBy || n.CreatedBy || null,
        }))
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Erro ao marcar notificação como lida: ${err.data.title || err.message}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.$isLoading = false
      }
    },
    async adicionarAnotacao() {
      if (!this.novaAnotacao.trim()) return

      const payload = {
        DealId: this.deal.id,
        Content: this.novaAnotacao.trim(),
        IsSystem: false,
      }

      this.$isLoading = true
      try {
        const res = await api.createDealNote(this.deal.id, payload)
        const n = res && res.data ? res.data : null
        if (n) {
          this.historico.unshift({
            id: n.id || n.Id || 0,
            texto: n.content || n.Content || this.novaAnotacao.trim(),
            data: n.createdAt || n.CreatedAt || moment().format('DD/MM/YYYY HH:mm'),
            isSystem: n.isSystem || n.IsSystem || false,
            createdBy: n.createdBy || n.CreatedBy || null,
          })
        }
        this.novaAnotacao = ''
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Erro ao marcar notificação como lida: ${err.data.title || err.message}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.$isLoading = false
      }
    },
    deletarAnotacao(noteId) {
      this.$confirmar(
        'Deseja realmente excluir esta anotação?',
        'Essa ação não pode ser desfeita.',
        'question', 'danger',
      ).then(result => {
        if (!result || !result.value) return
        this.$isLoading = true
        api.deleteDealNote(noteId)
          .then(() => {
            this.historico = this.historico.filter(h => h.id !== noteId)
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Erro ao marcar notificação como lida: ${err.data.title || err.message}`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          })
          .finally(() => {
            this.$isLoading = false
          })
      })
    },
    carregarOportunidadeStatus() {
      return [
        { id: 1, name: 'Em andamento' },
        { id: 2, name: 'Concluida' },
        { id: 3, name: 'Perdida' },
        { id: 4, name: 'Aguardando cliente' },
        { id: 5, name: 'Cancelada' },
      ]
    },
  },
}
</script>
